import React from 'react';
import { Panel } from 'react-bootstrap';

import GoogleMapReact from 'google-map-react';
import EventMapMarker from '../EventMapMarker';
import EventMapItem from '../EventMapItem';

class MapWidget extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selected: null,
    };
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }
  onSelect = (eventId) => {
    this.setState({ selected: eventId });
  }
  render() {
    const stops = this.props.tour.tour_stops;
    if (stops.length === 0) {
      return null;
    }

    const mapStays = [];
    const cardStays = [];

    let currentStop = stops[0];
    const centerXY = {
      lat: currentStop.place.position.coordinates[1],
      lng: currentStop.place.position.coordinates[0],
    };
    for (let i = 0; i < stops.length; i++) {
      currentStop = stops[i];
      // console.log("currentStop: ", i, currentStop.id);
      let nextStop = null;
      if (i+1 < stops.length) {
        nextStop = stops[i+1];
      }
      if (currentStop.id === this.state.selected) {
        centerXY.lat = currentStop.place.position.coordinates[1];
        centerXY.lng = currentStop.place.position.coordinates[0];
      }
      cardStays.push((
        <EventMapItem
          key={currentStop.id}
          event={currentStop}
          selected={currentStop.id === this.state.selected}
          onSelect={this.onSelect}
        />
      ));
      mapStays.push((
        <EventMapMarker
          key={currentStop.id}
          event={currentStop}
          nextEvent={nextStop}
          lat={currentStop.place.position.coordinates[1]}
          lng={currentStop.place.position.coordinates[0]}
          selected={currentStop.id === this.state.selected}
          onSelect={this.onSelect}
        />
      ));
    }
    const listStyle = { overflowY: 'auto', maxHeight: 590 };

    return (
      <div className="col-sm-12">
        <Panel header="Map">
          <div className="col-sm-4" style={{ height: 600 }} >
            <ul style={listStyle}>
              {cardStays}
            </ul>
          </div>
          <div className="col-sm-8" style={{ height: 600 }}>
            <GoogleMapReact
              bootstrapURLKeys={{ key: 'AIzaSyC_dfJjkQ_rwR1TLJ1ZKWUZcttrzDypBJ0' }}
              defaultZoom={7}
              center={centerXY}
            >
              {mapStays}
            </GoogleMapReact>
          </div>
        </Panel>
      </div>
    );
  }
}
export default MapWidget;



// WEBPACK FOOTER //
// src/routes/tours/components/widgets/MapWidget.js